export default __webpack_public_path__ + "static/photo8usluge-063757b8525308ca4dcd999644ef6b5c.png";